import React from 'react';
import PropTypes from 'prop-types';
import {
  mapCropView,
  mapFarmView
} from '../../../utilities/changeSummaryTools';
import AddedTableView from './AddedTableView';
import DeletedAndChangedTableView from './DeletedAndChangedTableView';

const cropViewDefaultPropMassiveChangeSummary = {};
const CropView = ({
  massiveChangeSummary = cropViewDefaultPropMassiveChangeSummary
}) => {
  const mappedFarmView = mapFarmView(
    massiveChangeSummary.fieldsToMassiveAssign
  );

  const mappedCropView = mapCropView(
    massiveChangeSummary.fieldsToMassiveAssign
  );

  return massiveChangeSummary.action === 'Added' ? (
    <AddedTableView
      mappedFarmView={mappedFarmView}
      massiveChangeSummary={massiveChangeSummary}
    />
  ) : (
    <DeletedAndChangedTableView
      mappedCropView={mappedCropView}
      massiveChangeSummary={massiveChangeSummary}
    />
  );
};

CropView.propTypes = {
  massiveChangeSummary: PropTypes.shape()
};

export default CropView;
